module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "reservation-modal payment dark-top",
    attrs: {
      "dialog": "modal-lg"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Payment Options")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.headerSubTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "bg-lighter",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "w-100 px-4 pt-4 bg-lightest"
  }, [_c('div', {
    staticClass: "col-sm-12 d-flex flex-row justify-content-between"
  }, [_c('label', [_vm._v("Select payment method")]), _vm._v(" "), _c('label', [_vm._v("Amount Received")])]), _vm._v(" "), _vm._l((_vm.tempBilling.payments), function(payment, index) {
    return _c('div', {
      staticClass: "col-sm-12 mt-3 pb-2"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-9 d-flex flex-row flex-wrap"
    }, _vm._l((_vm.getPaymentTypeListAll), function(paymentMethod) {
      return _c('div', {
        staticClass: "payMethod radius-normal text-center border-medium py-3 d-flex flex-column justify-content-between mr-2 mb-2 pointer",
        class: {
          selected: paymentMethod.id == payment.type
        },
        on: {
          "click": function($event) {
            return _vm.selectPayMethod(payment, paymentMethod)
          }
        }
      }, [_c('div', [(paymentMethod.icon) ? _c('i', {
        staticClass: "ico dark fs-largest m-0",
        class: paymentMethod.icon
      }) : (paymentMethod.img) ? _c('img', {
        staticStyle: {
          "max-width": "60%"
        },
        attrs: {
          "src": paymentMethod.img,
          "alt": paymentMethod.description
        }
      }) : _vm._e()]), _vm._v(" "), _c('span', {
        staticClass: "payeLabel darkest font-weight-600"
      }, [_vm._v(_vm._s(paymentMethod.description))])])
    }), 0), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('div', {
      staticClass: "col-sm-3 d-flex justify-content-center"
    }, [_c('loader')], 1) : _c('div', {
      staticClass: "col-sm-3 d-flex align-items-start"
    }, [_c('div', {
      staticClass: "d-flex flex-row align-items-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (payment.value),
        expression: "payment.value"
      }],
      staticClass: "fs-largest w-100 text-right bg-lighter glued-right",
      attrs: {
        "type": "number",
        "step": ".01",
        "min": "0",
        "placeholder": "0"
      },
      domProps: {
        "value": (payment.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(payment, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "border-light glued-left fs-largest py-2 px-2"
    }, [_vm._v("€")])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 row mx-0 px-0 pb-2 border-top-light pt-3"
  }, [_c('div', {
    staticClass: "col-sm-12 d-flex align-items-center"
  }, [_c('label', {
    staticClass: "mr-2"
  }, [_vm._v("\n                        Notes\n                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempBilling.payments[0].description),
      expression: "tempBilling.payments[0].description"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tempBilling.payments[0].description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempBilling.payments[0], "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 d-flex align-items-end my-2 justify-content-end"
  }, [_c('label', {
    staticClass: "mr-3"
  }, [_vm._v("\n                        Outstanding\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "fs-large font-weight-600",
    class: {
      'color-6': _vm.outstandingAmout < 0, 'color-3': _vm.outstandingAmout == 0
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.outstandingAmout)) + " €")]), _vm._v(" "), _c('label', {
    staticClass: "mx-3"
  }, [_vm._v("\n                        Total\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "fs-large font-weight-600",
    class: {
      'color-6': _vm.outstandingAmout < 0, 'color-3': _vm.outstandingAmout == 0
    }
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.grandTotal)) + " €")])])])], 2)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel widest",
    attrs: {
      "type": "button",
      "disabled": _vm.getIsAddingReservation
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok widest",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.getIsAddingReservation
    },
    on: {
      "click": function($event) {
        return _vm.save(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.saveButtonLabel))]), _vm._v(" "), _c('button', {
    staticClass: "btn blue ok widest",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.getIsAddingReservation
    },
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.saveAndPrintButtonLabel))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-50af85bc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50af85bc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationPay.vue
// module id = 1207
// module chunks = 0